import { CURRICULUM_KEYS } from '@mathflat/domain/Curriculum'

import commonRepo from '@/repository/common.repo'

export const STUDENT_ORDER = [
  '최신 등록순',
  '이름 오름차순',
  '이름 내림차순',
  '학년 오름차순',
  '학년 내림차순',
] as const

// curriculum core에서 가져올 수 없어서 상수 trieKey 추가
export const SUBJECT_LABEL = [
  {
    label: '확률과 통계',
    value: 'PROBABILITY_AND_STATISTICS_15',
    trieKey: CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_확률과통계,
  },
  {
    label: '미적분',
    value: 'CALCULUS_15',
    trieKey: CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_미적분,
  },
  { label: '기하', value: 'GEOMETRY_15', trieKey: CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_기하 },
] as const

export const DEPARTMENT_LABEL = [
  { value: 'LIBERAL', label: '문과' },
  { value: 'SCIENCE', label: '이과' },
] as const

export const DEPARTMENT_LABEL_EXPANDED = [
  { value: 'ALL', label: '문이과 전체' },
  ...DEPARTMENT_LABEL,
] as const

export const DEPARTMENT_SUBJECT_LABEL_EXPANDED = [
  { label: '계열·과목 전체', value: 'ALL' },
  ...SUBJECT_LABEL,
  ...DEPARTMENT_LABEL,
] as const

export const SCORE = [
  { label: '2점', value: 2 },
  { label: '3점', value: 3 },
  { label: '4점', value: 4 },
] as const

const PROBLEM_TYPE = [
  {
    label: '객관식',
    value: 'CHOICE',
  },
  { label: '주관식', value: 'SHORT_ANSWER' },
] as const
export const PROBLEM_TYPE_WITH_ALL = [{ label: '전체', value: 'ALL' }, ...PROBLEM_TYPE] as const

// 수업준비 - 시험·영역별 학습지 태그
export const EXAM_AND_CATEGORY_WORKSHEET_TAG_LIST = [
  { value: 'ARITHMETIC', label: '연산' },
  { value: 'ENTRANCE_TEST', label: commonRepo.isSchoolflat ? '진단평가' : '입학TEST' },
  { value: 'DAILY_TEST', label: '일일TEST' },
  { value: 'WEEKLY_TEST', label: '주간TEST' },
  { value: 'CHAPTER_TEST', label: '단원TEST' },
  { value: 'GENERAL_TEST', label: '총괄TEST' },
  { value: 'SCHOOL_PREPARE', label: commonRepo.isSchoolflat ? '교과서 쌍둥이' : '내신대비' },
  { value: 'SCHOOL_PREPARE_ESSAY', label: '서술형' },
  { value: 'PRACTICE_TEST', label: '모의고사' },
  { value: 'PRACTICE_TEST_PAIR', label: '모의고사 쌍둥이' },
  { value: 'CSA_TEST', label: '수능대비' },
  { value: 'MY_DB_ORIGINAL', label: '원본' },
  { value: 'SCHOOL_TEST_PAPER', label: '기출 유사' },
  { value: 'CUSTOM_PAPER', label: '기타자료 유사' },
  { value: 'CONCEPT_CHIP', label: '유형별 학습' },
  { value: 'CONCEPT_CHIP_WEAK_PROBLEM', label: '유형별 오답' },
  { value: 'WEAK_CONCEPT_CHIP', label: '취약유형' },
  { value: 'WEAK_CONCEPT_CHIP_BY_GROUP', label: '그룹취약유형' },
  { value: 'ETC', label: '기타' },
] as const

// 수업준비 - 학습지 태그 (공통)
export const WORKSHEET_TAG_LIST = [
  { value: 'BASIC', label: '기본' },
  { value: 'PRACTICE', label: '연습문제' },
  { value: 'HOMEWORK', label: '숙제' },
  { value: 'REVIEW', label: '복습' },
  ...EXAM_AND_CATEGORY_WORKSHEET_TAG_LIST,
] as const

export const WORKSHEET_TAG_LIST_EXPANDED = [
  { value: 'ALL', label: '태그 전체' },
  ...WORKSHEET_TAG_LIST,
] as const

// 수업 - 학습지 태그 (는 수업준비 학습지 태그에 몇가지 추가 된 것임)
export const ALL_WORKSHEET_TAG_LIST = [
  ...WORKSHEET_TAG_LIST.slice(0, WORKSHEET_TAG_LIST.length - 1),
  { value: 'WEAK_CHAPTER', label: '단원별 취약' },
  { value: 'WEAK_DATE', label: '기간별 오답' },
  { value: 'WEAK_WORKSHEET', label: '학습지 오답' },
  { value: 'WEAK_ARITHMETIC', label: '연산 오답' },
  { value: 'WEAK_WORKBOOK', label: '교재 오답' },
  { value: 'ETC', label: '기타' },
] as const

export const ALL_WORKSHEET_TAG_LIST_EXPANDED = [
  { value: 'ALL', label: '태그 전체' },
  ...ALL_WORKSHEET_TAG_LIST,
] as const

export const ALL_WORKSHEET_TAG_LIST_DISABLABLE_EXPANDED = (disabled) =>
  ALL_WORKSHEET_TAG_LIST_EXPANDED.map((tag) => {
    if (DERIVATION_TAG_LIST.filter((d) => d === tag.value).length > 0) {
      return { ...tag, disabled }
    }
    return { ...tag, disabled: false }
  })

export const DERIVATION_TAG_LIST = [
  'WEAK_CHAPTER',
  'WEAK_DATE',
  'WEAK_WORKSHEET',
  'WEAK_ARITHMETIC',
  'WEAK_WORKBOOK',
  'REVIEW',
] as const

export const ALL_WORKSHEET_TAG_LIST_WITHOUT_DERIVATION = (() => {
  return ALL_WORKSHEET_TAG_LIST.filter(({ value }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return !DERIVATION_TAG_LIST.includes(value)
  }).map(({ value }) => value)
})()

// 교과서 출판사. key 는 서버가 교과서 학습지의 publisher 컬럼과 그대로 비교하는 DB 문자열(서버 enum 이 아니다), value 는 화면 이름.
// key 가 곧 서버 값이라 영문 코드로 바꾸면 schoolWorkbookPublishers 필터가 깨진다.
export const 내신대비교과서 = {
  교학사: '교학사',
  금성출판사: '금성',
  '동아출판(강)': '동아(강)',
  '동아출판(박)': '동아(박)',
  미래엔: '미래엔',
  비상교육: '비상교육',
  좋은책신사고: '좋은책 신사고',
  지학사: '지학사',
  '천재교육(류)': '천재교육(류)',
  '천재교육(이)': '천재교육(이)',

  // 22개정 교과서
  비상: '비상',
  동아출판: '동아',
  와이비엠: '와이비엠',
  능률: '능률',
  '천재(김화경)': '천재(김화경)',
  '천재(김동재)': '천재(김동재)',
  '천재교육(전)': '천재교육(전)',
  '천재교육(홍)': '천재교육(홍)',
} as const

export const 내신대비교과서학습지 = {
  [CURRICULUM_KEYS.CURRICULUM_KEY_중학교_1학년_22개정]: {
    교학사: 내신대비교과서.교학사,
    능률: 내신대비교과서.능률,
    동아: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상: 내신대비교과서.비상,
    와이비엠: 내신대비교과서.와이비엠,
    지학사: 내신대비교과서.지학사,
    '천재(김화경)': 내신대비교과서['천재(김화경)'],
    '천재(김동재)': 내신대비교과서['천재(김동재)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_중학교_1학년]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    '동아출판(강)': 내신대비교과서['동아출판(강)'],
    '동아출판(박)': 내신대비교과서['동아출판(박)'],
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_중학교_2학년]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    '동아출판(강)': 내신대비교과서['동아출판(강)'],
    '동아출판(박)': 내신대비교과서['동아출판(박)'],
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_중학교_2학년_22개정]: {
    교학사: 내신대비교과서.교학사,
    능률: 내신대비교과서.능률,
    동아: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상: 내신대비교과서.비상,
    와이비엠: 내신대비교과서.와이비엠,
    지학사: 내신대비교과서.지학사,
    '천재(김화경)': 내신대비교과서['천재(김화경)'],
    '천재(김동재)': 내신대비교과서['천재(김동재)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_중학교_3학년]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    '동아출판(강)': 내신대비교과서['동아출판(강)'],
    '동아출판(박)': 내신대비교과서['동아출판(박)'],
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_공통수학1_22개정]: {
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    지학사: 내신대비교과서.지학사,
    와이비엠: 내신대비교과서.와이비엠,
    '천재교육(전)': 내신대비교과서['천재교육(전)'],
    '천재교육(홍)': 내신대비교과서['천재교육(홍)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_수학_상]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_공통수학2_22개정]: {
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    지학사: 내신대비교과서.지학사,
    와이비엠: 내신대비교과서.와이비엠,
    '천재교육(전)': 내신대비교과서['천재교육(전)'],
    '천재교육(홍)': 내신대비교과서['천재교육(홍)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_수학_하]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_수학I]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_수학II]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_확률과통계]: {
    교학사: 내신대비교과서.교학사,
    금성출판사: 내신대비교과서.금성출판사,
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_미적분]: {
    교학사: 내신대비교과서.교학사,
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_기하]: {
    교학사: 내신대비교과서.교학사,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    좋은책신사고: 내신대비교과서.좋은책신사고,
    지학사: 내신대비교과서.지학사,
    '천재교육(류)': 내신대비교과서['천재교육(류)'],
    '천재교육(이)': 내신대비교과서['천재교육(이)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_기하_22개정]: {
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    지학사: 내신대비교과서.지학사,
    와이비엠: 내신대비교과서.와이비엠,
    '천재교육(전)': 내신대비교과서['천재교육(전)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_확률과통계_22개정]: {
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    지학사: 내신대비교과서.지학사,
    와이비엠: 내신대비교과서.와이비엠,
    '천재교육(전)': 내신대비교과서['천재교육(전)'],
  },

  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_대수_22개정]: {
    와이비엠: 내신대비교과서.와이비엠,
    비상교육: 내신대비교과서.비상교육,
    미래엔: 내신대비교과서.미래엔,
    동아출판: 내신대비교과서.동아출판,
    지학사: 내신대비교과서.지학사,
    '천재교육(전)': 내신대비교과서['천재교육(전)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_미적분1_22개정]: {
    와이비엠: 내신대비교과서.와이비엠,
    비상교육: 내신대비교과서.비상교육,
    미래엔: 내신대비교과서.미래엔,
    동아출판: 내신대비교과서.동아출판,
    지학사: 내신대비교과서.지학사,
    '천재교육(홍)': 내신대비교과서['천재교육(홍)'],
  },
  [CURRICULUM_KEYS.CURRICULUM_KEY_고등학교_미적분2_22개정]: {
    동아출판: 내신대비교과서.동아출판,
    미래엔: 내신대비교과서.미래엔,
    비상교육: 내신대비교과서.비상교육,
    지학사: 내신대비교과서.지학사,
    와이비엠: 내신대비교과서.와이비엠,
    '천재교육(홍)': 내신대비교과서['천재교육(홍)'],
  },
} as const
